/**
 * The one exception to "no top bar" — mobile only, opens the nav drawer.
 * Scrolls away with the page; not sticky.
 * Spec: assets/handoffs/design_handoff_app_shell, Rules — mobile.
 *
 * @param {string=} workspaceInitials
 * @param {string=} workspaceIcon - uploaded org favicon URL, beats initials when set
 * @param {string=} branding - appConfig.branding, for the logo asset path
 * @param {function} onMenuClick
 */
import React from "react";
import { Link } from "react-router-dom";
import Icon from "../../../theme/untitled/icons/Icon";
import styles from "./MobileTopBar.module.scss";

const MobileTopBar = ({ workspaceInitials, workspaceIcon, branding = "revisual", onMenuClick }) => (
  <div className={styles.bar}>
    <button type="button" className={styles.menuButton} aria-label="Open navigation" onClick={onMenuClick}>
      <Icon name="AlignJustify" className={styles.menuIcon} />
    </button>
    <Link to="/dashboard" className={styles.logo}>
      <img src={`/img/branding/${branding}/full_length_logo.png`} height="24" alt="" />
    </Link>
    <span className={styles.workspaceAvatar}>
      {workspaceIcon ? (
        <img src={workspaceIcon} alt="" className={styles.workspaceAvatarImg} />
      ) : (
        workspaceInitials
      )}
    </span>
  </div>
);

export default MobileTopBar;
